export default __webpack_public_path__ + "content/55dd10d800004307039739d84d819642.png";